export default "/images/Device_reuna.png?4ec7f407620923392dac62253df5c158";